// Roles y permisos del módulo administrador. La API es la autoridad (políticas y AlcanceService);
// aquí sólo se decide qué mostrar u ocultar.
import { idsSubarbol } from './categoriasArbol';

export const ROLES = {
  SUPER_ADMIN: 'SuperAdmin',
  ADMIN_INSTITUCION: 'AdminInstitucion',
  PUBLICADOR: 'Publicador',
};

export const ETIQUETAS_ROL = {
  [ROLES.SUPER_ADMIN]: 'SuperAdmin (plataforma)',
  [ROLES.ADMIN_INSTITUCION]: 'Administrador de institución',
  [ROLES.PUBLICADOR]: 'Publicador',
};

export const esSuperAdmin = (usuario) => Boolean(usuario) && usuario.rol === ROLES.SUPER_ADMIN;
export const esAdminInstitucion = (usuario) => Boolean(usuario) && usuario.rol === ROLES.ADMIN_INSTITUCION;
export const esPublicador = (usuario) => Boolean(usuario) && usuario.rol === ROLES.PUBLICADOR;

export const puedeGestionarCategorias = (usuario) => esSuperAdmin(usuario) || esAdminInstitucion(usuario);
export const puedeGestionarUsuarios = (usuario) => esSuperAdmin(usuario) || esAdminInstitucion(usuario);
export const puedeEditarBranding = (usuario) => esSuperAdmin(usuario) || esAdminInstitucion(usuario);
export const puedeGestionarInstituciones = (usuario) => esSuperAdmin(usuario);

// Roles que un usuario puede asignar a otros.
export const rolesAsignables = (usuario) =>
  esSuperAdmin(usuario)
    ? [ROLES.SUPER_ADMIN, ROLES.ADMIN_INSTITUCION, ROLES.PUBLICADOR]
    : [ROLES.ADMIN_INSTITUCION, ROLES.PUBLICADOR];

/**
 * Ids de categorías en las que el usuario puede publicar, o null si no tiene restricción.
 * Para un publicador: el subárbol completo de cada categoría raíz asignada.
 */
export const idsCategoriasEnAlcance = (usuario, categorias) => {
  if (!esPublicador(usuario)) return null;
  const ids = new Set();
  (usuario.categoriasRaiz || []).forEach((raiz) => {
    idsSubarbol(categorias, raiz).forEach((id) => ids.add(id));
  });
  return ids;
};
